import themePreval from './utils/theme-preval2.js';

var defaultTheme = themePreval.theme;

// ThemeColors and ThemeShadows were originally handcrafted types.

// type ThemeColors = {
//   surface: {
//     default: string
//     sunken: string
//     raised: string
//     overlay: string
//   }
//   border: {
//     default: string
//     focused: string
//     subtle: string
//     input: string
//     disabled: string
//     brand: string
//     selected: string
//     danger: string
//     warning: string
//     success: string
//     discovery: string
//     information: string
//     accent: object
//   }
//   text: {
//     default: string
//     subtle: string
//     subtlest: string
//     disabled: string
//     inverse: string
//     brand: string
//     selected: string
//     danger: string
//     warning: object
//   }
//   background: {
//     blanket: {
//       default: string
//     }
//   }
// }

export { defaultTheme as default };
